import {Sentence} from '../models/resources';

export default {
  getSentences: ({ commit }) => {
    Sentence.query().then((response) => {
      commit('sentences', response.body.data.map(sentence => sentence.attributes))
    })
  },

  saveSentence: ({ commit }, sentence) => {
    return new Promise((resolve, reject) => {
      if (sentence.id) {
        Sentence.update({
          id: sentence.id
        }, {
          sentence: sentence
        }).then((res) => {
          commit('updateSentence', res.body)
           resolve(res.body);
        }, (res) => {
           reject(res);
        });
      } else {
        Sentence.save({
          sentence: sentence
        }).then((res) => {
           commit('addSentence', res.body)
           resolve(res.body);
        }, (res) => {
           reject(res.body);
        });
      }
    });
  }

}




// WEBPACK FOOTER //
// ./src/store/actions/sentences.js